import React from "react";
import dayjs from "dayjs";

import ArrowDownwardIcon from "@mui/icons-material/ArrowDownward";
import ArrowUpwardIcon from "@mui/icons-material/ArrowUpward";
import DeleteOutlineIcon from "@mui/icons-material/DeleteOutline";
import Box from "@mui/material/Box";
import Card from "@mui/material/Card";
import Chip from "@mui/material/Chip";
import IconButton from "@mui/material/IconButton";
import Tooltip from "@mui/material/Tooltip";
import Typography from "@mui/material/Typography";

export default function ProjectComponentFrame({
    children,
    component,
    isEditing,
    label,
    onDelete,
    onMoveDown,
    onMoveUp,
}) {
    return (
        <Card
            variant="outlined"
            sx={{
                borderRadius: 3,
                borderColor: "divider",
                boxShadow: "0 8px 28px rgba(20, 35, 25, 0.055)",
                overflow: "hidden",
            }}
        >
            {isEditing && (
                <Box
                    sx={{
                        minHeight: 54,
                        px: { xs: 1.5, sm: 2 },
                        py: 1,
                        display: "flex",
                        alignItems: "center",
                        gap: 1,
                        borderBottom: "1px solid",
                        borderColor: "divider",
                        backgroundColor: "background.subtle",
                    }}
                >
                    <Chip
                        size="small"
                        label={label}
                        sx={{
                            backgroundColor: "rgba(0, 149, 61, 0.09)",
                            color: "primary.main",
                            fontWeight: 700,
                        }}
                    />
                    <Box sx={{ flex: 1 }} />
                    <Tooltip title="Move up">
                        <IconButton
                            size="small"
                            aria-label={`Move ${label.toLowerCase()} up`}
                            onClick={onMoveUp}
                        >
                            <ArrowUpwardIcon fontSize="small" />
                        </IconButton>
                    </Tooltip>
                    <Tooltip title="Move down">
                        <IconButton
                            size="small"
                            aria-label={`Move ${label.toLowerCase()} down`}
                            onClick={onMoveDown}
                        >
                            <ArrowDownwardIcon fontSize="small" />
                        </IconButton>
                    </Tooltip>
                    <Tooltip title="Delete">
                        <IconButton
                            size="small"
                            color="error"
                            aria-label={`Delete ${label.toLowerCase()}`}
                            onClick={onDelete}
                        >
                            <DeleteOutlineIcon fontSize="small" />
                        </IconButton>
                    </Tooltip>
                </Box>
            )}
            <Box sx={{ p: { xs: 2, sm: 2.5 } }}>{children}</Box>
            {component?.addedByName && (
                <Box
                    sx={{
                        px: { xs: 2, sm: 2.5 },
                        py: 1.25,
                        borderTop: "1px solid",
                        borderColor: "divider",
                        backgroundColor: "background.subtle",
                    }}
                >
                    <Typography variant="caption" color="text.secondary">
                        Added by {component.addedByName}
                        {component.addedOn
                            ? ` · ${dayjs(component.addedOn).format(
                                  "D MMM YYYY",
                              )}`
                            : ""}
                    </Typography>
                </Box>
            )}
        </Card>
    );
}
